var Display;
(function (Display) {
    Display[Display["VISIBLE"] = 0] = "VISIBLE";
    Display[Display["NONE"] = 1] = "NONE";
})(Display || (Display = {}));
export default Display;
